module.exports = __webpack_public_path__ + "img/MNEX32-default-front.68371d53.jpg";